export default "__VITE_ASSET__65ocGx07__"